import React, { useState } from 'react';
import '../styles/FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What exactly are AI agents and how do they work?",
      answer: "AI agents are specialized artificial intelligence tools trained to perform specific business tasks. You simply select an agent, describe your goal in everyday language, and the AI handles the execution. No coding or technical knowledge required."
    },
    {
      question: "How does the affiliate finding process work?",
      answer: "Our AI Influencer Outreach Manager analyzes your business, product, and target audience, then matches you with relevant affiliates from our database of 200+ pre-vetted influencers. It then drafts personalized outreach messages and helps you manage the relationships."
    },
    {
      question: "Do I need any technical skills to use the platform?",
      answer: "Absolutely not! Our platform is designed for business owners without technical expertise. If you can write an email, you can use our AI agents. Simply describe what you want in plain language, and the AI handles the technical execution."
    },
    {
      question: "Which social media platforms are supported?",
      answer: "We currently support Instagram, YouTube, LinkedIn, TikTok, and Facebook. Our AI can create platform-specific content, schedule posts at optimal times, and even help manage comments and engagement."
    },
    {
      question: "How much time does it typically take to set up?",
      answer: "Most users are up and running within minutes after getting access. The initial setup involves a brief onboarding where the AI learns about your business and brand voice. After that, you can immediately start using the agents."
    },
    {
      question: "Is my data safe and secure?",
      answer: "Yes, we take data security very seriously. All your business data is encrypted, and we don't share your information with third parties. Our AI learns from your preferences but keeps your specific business data private and secure."
    },
    {
      question: "When will I get access after signing up?",
      answer: "We're currently onboarding new users in batches to ensure everyone gets proper support. After submitting your information, you'll be added to our waitlist, and we'll notify you as soon as your access is ready."
    }
  ];

  return (
    <section className="faq">
      <div className="container">
        <h2>Frequently Asked <span className="highlight">Questions</span></h2>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`} 
              key={index}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="faq-more">
          <p>Still have questions? Contact our support team and we'll be happy to help.</p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
